module.exports = __webpack_public_path__ + "img/kebelet-iphone_box.9679cc20.png";